import { ApiCreateSalesOrder, ApiDeleteSalesOrder, ApiGetOrderList, ApiGetOrderSalesStockList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse, DateFormat } from "utils/helpers";

export function SalesOrderService() {
    const { showFail } = useModal()

    const { fetch: apiGetSalesOrderList } = useFetch(ApiGetOrderList)
    const { fetch: apiGetOrderSalesStockList } = useFetch(ApiGetOrderSalesStockList)
    const { fetch: apiCreateSalesOrder } = useFetch(ApiCreateSalesOrder)
    const { fetch: apiDeleteSalesOrder } = useFetch(ApiDeleteSalesOrder)

    const fetchSalesOrderList = async(orderDateFrom, orderDateTo, paymentType, status, pageSize, index) => {
        const res =  await apiGetSalesOrderList({
            data: {
                orderDateFrom: DateFormat(orderDateFrom),
                orderDateTo: DateFormat(orderDateTo),
                paymentType,
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchOrderSalesStockList = async(categoryId, searchParam) => {
        const res = await apiGetOrderSalesStockList({
            data: {
                categoryId,
                searchParam
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    } 
    const fetchCreateOrderSales = async(cart, paymentType, tax, total, discount, grandTotal) => {
        let items = []

        cart.map((data, i) => items.push({ 
            productId: data.productId, 
            quantity: data.qty, 
            productName: data.productName, 
            brandName: data.brandName, 
            tax: tax,
            size: data.size,
            nettPrice: data.finalPrice
        }))

        const res = await apiCreateSalesOrder({
            data: {
                items, 
                paymentType,
                tax: parseInt(tax), 
                amount: total.replaceAll(',', ''),
                discount: parseInt(discount),
                nettAmount: grandTotal.replaceAll(',', ''),
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteSalesOrder = async(orderId, status) => {
        const res = await apiDeleteSalesOrder({
            data: {
                orderId, 
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchSalesOrderList,
        fetchOrderSalesStockList,
        fetchCreateOrderSales,
        fetchDeleteSalesOrder
    }
}